<template>
  <div v-if="visible" class="popup z-50">
    <div class="popup-content rounded-lg overflow-hidden">
      <a
        class="popup-media"
        v-if="popup?.link_type == 0"
        :href="getExternalLink(popup?.link)"
        target="_blank"
        rel="noopener noreferrer"
        @click="closePopup"
      >
        <img class="popup-image" :src="popup.image" :alt="popup.title" />
      </a>
      <a class="popup-media" v-else @click.prevent="linkClicked" href="#">
        <img class="popup-image" :src="popup.image" :alt="popup.title" />
      </a>
      <div v-if="!ended" class="progress-container absolute top-0 right-0">
        <svg viewBox="0 0 36 36" class="circular-chart">
          <path
            class="circle-bg"
            d="M18 2.0845
                 a 15.9155 15.9155 0 0 1 0 31.831
                 a 15.9155 15.9155 0 0 1 0 -31.831"
          />
          <path
            fill="#ffffff"
            class="circle"
            :stroke-dasharray="progress + ', 100'"
            d="M18 2.0845
                 a 15.9155 15.9155 0 0 1 0 31.831
                 a 15.9155 15.9155 0 0 1 0 -31.831"
          />
        </svg>
        <span>{{ remainingTime }}</span>
      </div>
      <div v-else class="absolute top-0 right-0">
        <button @click="closePopup" class="bg-red-500 rounded-full p-1 m-2">
          <IconClose class="[&>path]:stroke-white" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import IconClose from '@icons/IconClose.vue';
import { LINK_TYPE } from '@/constants';
import { getExternalLink } from '@/helpers';
export default {
  props: {
    popup: {
      type: Object,
      required: true,
    },
  },
  components: {
    IconClose,
  },
  data() {
    return {
      visible: true,
      remainingTime: this.popup.duration,
      progress: 100,
      ended: false,
      linkType: LINK_TYPE,
      timeout: null,
    };
  },
  methods: {
    getExternalLink,

    linkClicked() {
      this.$router.push({
        name: this.linkType[this.popup?.link_type].route,
        params: { id: this.popup?.link },
      });
      clearInterval(this.interval);
      this.closePopup();
    },
    handleClick() {
      window.open(this.getExternalLink(this.popup?.link), '_blank', 'noopener,noreferrer');
      this.closePopup();
    },
    closePopup() {
      clearInterval(this.interval);
      clearTimeout(this.timeout);
      this.visible = false;
      this.$emit('close');
    },
    updateProgress() {
      if (this.remainingTime > 0) {
        this.remainingTime--;
        this.progress = (this.remainingTime / this.popup.duration) * 100;
      } else {
        this.closePopup();
      }
    },
  },
  mounted() {
    this.interval = setInterval(this.updateProgress, 1000);
    this.timeout = setTimeout(() => {
      clearInterval(this.interval);
      this.ended = true;
      // this.closePopup();
    }, this.popup.duration * 1000);
  },
  beforeUnmount() {
    clearInterval(this.interval);
    clearTimeout(this.timeout);
  },
};
</script>

<style scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 16px;
}
.popup-content {
  width: 800px;
  height: 600px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  max-height: calc(100dvh - 32px);
  background: white;
  border-radius: 10px;
  text-align: center;
  position: relative;
}
.popup-media,
.popup-image {
  display: block;
  width: 100%;
  height: 100%;
}
.popup-image {
  object-fit: fill;
}
.progress-container {
  width: 50px;
  height: 50px;
}
.circular-chart {
  display: block;
  margin: 10px auto;
  max-width: 80%;
  max-height: 250px;
}
.circle-bg {
  fill: none;
  stroke: #eee;
  stroke-width: 3.8;
}
.circle {
  stroke-width: 3;
  stroke-linecap: round;
  stroke: #409dba;
  animation: progress 1s ease-out forwards;
}
.progress-container span {
  position: absolute;
  top: 58%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  font-weight: semibold;
}
@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}
</style>
